// dls
import { Button } from "@swiggy-private/dls-web-core/dist/components/Button";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// lib
import styled from "styled-components";

export const ErrorContainer = styled.div<{ showFullPage?: boolean; containerWidth?: string }>(
    ({ showFullPage, containerWidth }) => ({
        display: "flex",
        margin: "auto",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        maxWidth: containerWidth || "320px",
        minHeight: showFullPage ? "100vh" : "max-content",
    })
);

export const ImageComponent = styled(Image)(({ theme }) => ({
    marginBottom: theme.spacing.xLarge,
}));

export const HeadingWrapper = styled.div(({ theme }) => ({
    marginBottom: theme.spacing.xSmall,
}));

export const SubHeadingWrapper = styled.div(({ theme }) => ({
    marginBottom: theme.spacing.xLarge,
}));

export const RefreshButton = styled(Button)({
    textAlign: "center",
    width: "154px",
});
